import { useEffect, useRef } from "react";
import { Animated, Easing } from "react-native";

export const useRotation = (playing: boolean, duration = 2000) => {
  const anim = useRef(new Animated.Value(0)).current;
  const isMounted = useRef(true);

  const start = () => {
    anim.setValue(0);

    Animated.timing(anim, {
      toValue: 1,
      duration,
      easing: Easing.linear,
      useNativeDriver: true,
    }).start(({ finished }) => {
      if (finished && isMounted.current) {
        start(); // 🔁 manual loop
      }
    });
  };

  useEffect(() => {
    isMounted.current = true;

    if (playing) {
      start();
    } else {
      anim.stopAnimation();
      anim.setValue(0);
    }

    return () => {
      isMounted.current = false;
      anim.stopAnimation();
    };
  }, [playing, duration]);

  return anim;
};
